<i18n>
{
  "en": {
    "label": {
      "searchButton": "search",
      "clearButton": "clear",
      "latitudeName": "lat",
      "longitudeName": "lng"
    },
    "message": {
      "progress": "processing..."
    }
  },
  "ja": {
    "label": {
      "searchButton": "検索",
      "clearButton": "クリア",
      "latitudeName": "緯度",
      "longitudeName": "経度"
    },
    "message": {
      "progress": "処理中…"
    }
  }
}
</i18n>

<template>
  <div class="map-container">
    <div class="search-area">
      <div style="margin-bottom: -20px;">
        <TextInput
          name="searchText"
          v-model="searchText"
          :readonly="disabled"
        />
      </div>
      <div>
        <v-btn
          color="primary"
          @click="search"
          :disabled="disabled"
        >
          {{ $t('label.searchButton') }}
        </v-btn>
      </div>
    </div>
    <div style="border: solid 1px #000000; margin: 4px; position: relative;">
      <div v-show="zoom < minimumZoomLevel && !disabled" class="map-warning">
        撮影場所をクリックするには、地図を拡大してください。
      </div>
      <GmapMap
        :center="center"
        :zoom="zoom"
        :options="options"
        @click="mapClick"
        @zoom_changed="zoomChanged"
        ref="map"
        style="width: 100%; height: 400px;"
      >
        <GmapMarker
          v-if="marker && marker.position && marker.position.lat && marker.position.lng"
          :position="marker.position"
          :clickable="false"
          :draggable="false"
        ></GmapMarker>
      </GmapMap>
    </div>
    <div class="latlng-area">
      <div class="latlng-ui">
        <div style="margin-right: 8px;">{{ $t('label.latitudeName') }}</div>
        {{ marker.position.lat }}
      <!--
        {{ prefText }} {{ cityText }}<br />
        {{ addressText }}
      -->
      </div>
      <div class="latlng-ui">
        <div style="margin-right: 8px;">{{ $t('label.longitudeName') }}</div>
        {{ marker.position.lng }}
      </div>
      <div>
        <v-btn
          color="primary"
          @click="clear"
          :disabled="disabled"
        >
          {{ $t('label.clearButton') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
'use strict';
import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps'
import TextInput from '@/components/atoms/TextInput.vue';

export default {
  components: {
    TextInput
  },
  props: {
    value: String,
    defaultValue: String,
    disabled: Boolean
  },
  beforeMount() {
    if (this.value) {
      const latLng = this.value.split(',');
      const lat = parseFloat(latLng[0]);
      const lng = parseFloat(latLng[1]);
      this.marker = {
        position: {
          lat: lat,
          lng: lng
        }
      };

      this.center = {
        lat: lat,
        lng: lng
      };
    }
  },
  watch: {
    value(newValue) {
      if (!newValue) {
        this.marker = {
          position: {
            lat: null,
            lng: null
          }
        };
      }
    }
  },
  methods: {
    /**
     * マップクリック
     */
    mapClick(event) {
      if (this.zoom < this.minimumZoomLevel) return; //zoomレベルが足りない場合クリックさせない
      if (this.disabled) return;
      const lat = Math.round(event.latLng.lat() * 10000000) / 10000000;
      const lng = Math.round(event.latLng.lng() * 10000000) / 10000000;
      this.marker = {
        position: {
          lat: lat,
          lng: lng
        }
      };
      //親側も更新
      this.$emit('input', `${lat},${lng}`);

      Vue.$geocoder.setDefaultMode('lat-lng');
      Vue.$geocoder.send(this.marker.position, response => {
        if(response && response.status == 'OK') {
          this.prefText = this.getAddressName('administrative_area_level_1', response.results);
          this.cityText = this.getAddressName('locality', response.results);
          this.addressText = response.results[0].formatted_address;
          console.log(response);
        } else {
          console.log('latLng search failed.');
          console.log(response);
        }
      });
    },
    zoomChanged(zoom) {
      this.zoom = zoom;
    },
    /**
     * 住所検索
     */
    search() {
      const searchObj = {
        address_line_1: this.searchText
      };
      Vue.$geocoder.setDefaultMode('address');
      Vue.$geocoder.send(searchObj, response => {
        if(response && response.status == 'OK') {
          const center = {
            lat: response.results[0].geometry.location.lat,
            lng: response.results[0].geometry.location.lng
          };
          this.$refs.map.panTo(center);
        } else {
          console.log('address search failed.');
          console.log(response);
        }
      });
    },
    clear() {
      this.marker = {
        position: {
          lat: null,
          lng: null
        }
      };
      //親側も更新
      this.$emit('input', '');
    },
    /**
     * 都道府県取得
     */
    getAddressName(key, addressList) {
      for (let address of addressList) {
        let index = 0;
        for (let type of address.types) {
          if (type == key) {
            return address.address_components[index].long_name;
          }
          index++;
        }
      }
    },
  },
  mounted() {
  },
  data() {
    return {
      marker: {
        position: {
          lat: null,
          lng: null
        }
      },
      searchText: '',
      prefText: '',
      cityText: '',
      addressText: '',
      center: {
        lat: 35.681215,
        lng: 139.767074
      },
      zoom: 14, //初期ズームレベル
      minimumZoomLevel: 14, //クリック時の最小ズームレベル。これより拡大しないとクリックできない
      options: {
        clickableIcons: false,  //マップ中のアイコンクリックをdisableにした
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false
      }
    };
  }
};
</script>

<style scoped lang="stylus">
.map-container {
  width: 100%;
}
.map-warning {
  position: absolute;
  width: 100%;
  z-index: 99999;
  background-color: rgba(0,0,0,0.6);
  color: white;
  font-weight: bold;
  text-align: center;
  padding: 8px;
}
.search-area {
  height: 56px;
  display: flex;
  align-items: center;
}
.address-area {
  margin-left: 16px;
}
.latlng-area {
  margin-top: 6px;
  display: flex;
  flex-wrap : wrap;
  flex-direction row;
  align-items: center;
}
.latlng-ui {
  margin-left: 8px;
  padding: 8px;
  display: flex;
  flex-direction row;
  align-items: center;
  border: solid 1px #cccccc;
  border-radius: 6px;
  background-color: #ffffff;
}

</style>
